import * as React from 'react'
import { Tooltip, Button, Dialog, DialogContent } from '@mui/material'
import { UpTransition } from '../animations'

type AddWrapperInputProps = {
  legend: string;
  addTooltipTitle?: string;
  input: React.ReactNode;
  dialogContent?: (close: () => void) => React.ReactNode;
  onAfterClose?: () => void;
  openButtonVisible?: boolean;
  formMaxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
};

export function AddWrapperInput({
  legend,
  addTooltipTitle = 'Ajouter',
  input,
  dialogContent,
  onAfterClose,
  openButtonVisible = true,
  formMaxWidth
}: AddWrapperInputProps) {
  const [open, setOpen] = React.useState(false)

  const openDialog = () => setOpen(true)
  const closeDialog = () => {
    setOpen(false)
    onAfterClose?.()
  }

  return (
    <>
      <fieldset className="border border-gray-200 p-4 rounded-lg">
        <legend className="text-sm font-medium text-gray-700 mb-1 border border-gray-200 p-2 rounded-lg">
          <span>{legend}</span>
          <span className="inline-flex items-center">
            {openButtonVisible && dialogContent && (
              <Tooltip title={addTooltipTitle} arrow>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={openDialog}
                  sx={{
                    paddingTop: 0.5,
                    paddingBottom: 0.5,
                    paddingLeft: 1,
                    paddingRight: 1,
                    minWidth: 'auto',
                    width: 'auto',
                    marginLeft: 1,
                  }}
                >
                  <i className="fas fa-plus" />
                </Button>
              </Tooltip>
            )}
          </span>
        </legend>
        {input}
      </fieldset>

      {dialogContent && (
        <Dialog
          open={open}
          onClose={closeDialog}
          TransitionComponent={UpTransition}
          slotProps={{ backdrop: {} }}
          maxWidth={formMaxWidth ?? 'sm'}
          fullWidth={!!formMaxWidth}
        >
          <DialogContent>{open && dialogContent(closeDialog)}</DialogContent>
        </Dialog>
      )}
    </>
  )
}
